// @flow
import React from "react";
import { useSelector } from "react-redux";
import { isNil } from "ramda";
import {
  ID_OPCAO_DEFLATOR_NENHUM,
  ID_OPCAO_CORRETOR_MONETARIO_NENHUM,
} from "../../../model";
import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoPeriodicidade,
  SelecaoAjusteDias,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import CheckboxUltimaNegociacaoMes from "../configuracoes/periodos/CheckboxUltimaNegociacaoMes/CheckboxUltimaNegociacaoMes";
import SelecaoDeflacao from "../configuracoes/deflacao/SelecaoDeflacao";
import SelecaoNormalizacao from "../configuracoes/deflacao/SelecaoNormalizacao";
import SelecaoCorrecaoMonetaria from "../configuracoes/correcaoMonetaria/SelecaoCorrecaoMonetaria";

export const processarPontualDiarioDeflatorCorrecaoComFlagUltimaNegociacao = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    const configCorrecao =
      !isNil(edicaoMedida.corretorMonetario) &&
      edicaoMedida.corretorMonetario !== ID_OPCAO_CORRETOR_MONETARIO_NENHUM
        ? {
            correcaoMonetaria: edicaoMedida.corretorMonetario,
          }
        : {};
    const configDeflator =
      !isNil(edicaoMedida.deflator) &&
      edicaoMedida.deflator !== ID_OPCAO_DEFLATOR_NENHUM
        ? {
            deflator: edicaoMedida.deflator,
          }
        : {};
    const configValorDataBase =
      !isNil(edicaoMedida.valorBaseDeflator) &&
      !isNil(edicaoMedida.dataBaseDeflator)
        ? {
            valorBaseDeflator: edicaoMedida.valorBaseDeflator,
            valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
            dataBaseDeflator: edicaoMedida.dataBaseDeflator,
            dataBaseDeflatorDataEspecifica:
              edicaoMedida.dataBaseDeflatorDataEspecifica,
          }
        : {};

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        ...configCorrecao,
        ...configDeflator,
        ...configValorDataBase,
        ultimaNegociacao: edicaoMedida.ultimaNegociacaoMes,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        dataBase: dataBase,
        ...configCorrecao,
        ...configDeflator,
        ...configValorDataBase,
        ultimaNegociacao: edicaoMedida.ultimaNegociacaoMes,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PontualDiarioDeflatorCorrecaoComFlagUltimaNegociacao = () => {
  const modoSeries = useSelector(isModoSeries);

  return (
    <div>
      <div className="ConfiguracaoMedida--row">
        <SelecaoPeriodo exibirPeriodicidade={false} />
        <div className="ConfiguracaoMedida__group">
          <div className="ConfiguracaoMedida__box">
            <SelecaoPeriodicidade />
          </div>

          <div className="ConfiguracaoMedida__box">
            <SelecaoAjusteDias />
          </div>
        </div>

        <div className="ConfiguracaoMedida">
          <div className="ConfiguracaoMedida__box">
            {!modoSeries && (
              <SelecaoCasasDecimais className="ConfiguracaoMedida__fixed" />
            )}
          </div>
          <div className="ConfiguracaoMedida__box">
            <CheckboxUltimaNegociacaoMes />
          </div>
        </div>
      </div>

      <div className="ConfiguracaoMedida--row">
        <div className="ConfiguracaoMedida__group">
          <div className="ConfiguracaoMedida__box">
            <SelecaoDeflacao exibirNormalizacao={false} />
          </div>
        </div>

        <div className="ConfiguracaoMedida__group">
          <div className="ConfiguracaoMedida__box">
            <SelecaoCorrecaoMonetaria />
          </div>
        </div>

        <div className="ConfiguracaoMedida__group">
          <div className="ConfiguracaoMedida__box">
            <SelecaoNormalizacao
              forcarExibirNormalizacao={true}
              exibirOpcaoNenhum={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PontualDiarioDeflatorCorrecaoComFlagUltimaNegociacao;
